import React, { useState, useEffect } from "react";
import * as utils from "../../../helper/helper";
import * as transportService from "../findTransportService";

import { Button, Space, Modal } from "antd";
import Spinner from "../../common/spinner";
import { ToastContainer, toast } from "react-toastify";

function TransportTimeLine({ transport, onRefresh }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [nextDisable, setNextDisable] = useState(false);
  const [backDisable, setBackDisable] = useState(false);
  const [modalAction, setModalAction] = useState(null);
  const [isLoading, setLoading] = useState(false);


  useEffect(() => {
    if (transport && transport.event_time?.length > 0) {
      const validEvents = transport.event_time.filter(e => e.time);

      if (validEvents.length > 0) {
        const lastItem = validEvents[validEvents.length - 1];
        if (lastItem.title === "event_time_accepted_rider_ontheway_to_origin_in_ms") {
          setBackDisable(true);
        } else {
          setBackDisable(false);
        }

        if (lastItem.title === "event_time_active_completion_confirmed_by_rider_in_ms") {
          setNextDisable(true)
        } else {
          setNextDisable(false)
        }

      }
    }
  }, [transport]);


  const showModal = (action) => {
    setModalAction(action);
    setIsModalOpen(true);
  };
  const handleOk = () => {
    if (modalAction === "back") {
      adminPreviousState()
    } else if (modalAction === "next") {
      adminNextState()
    }
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  let lastTime = 0;
  const handleTimeStamp = (itemTime) => {
    if (lastTime !== 0) {
      const newTime = itemTime - lastTime;
      var min = newTime / 1000 / 60;
      var r = min % 1;
      var sec = Math.floor(r * 60);
      if (sec < 10) {
        sec = "0" + sec;
      }
      min = Math.floor(min);
      lastTime = itemTime;
      return <div className="timeline-line">{min + ":" + sec}</div>;
    } else {
      lastTime = itemTime;
    }
  };

  const handleTitle = (title) => {
    switch (title) {
      case "event_time_created_by_customer_in_ms":
        return "Order Created";
      case "event_time_created_processing_payment_in_ms":
        return "Processing Payment";
      case "event_time_created_payment_authorised_in_ms":
        return "Payment Authorised";
      case "event_time_search_first_attemp_in_ms":
        return "First Search";
      case "event_time_search_second_attemp_in_ms":
        return "Second Search";
      case "event_time_accepted_rider_ontheway_to_origin_in_ms":
        return "Rider Accepted";
      case "event_time_accepted_canceled_by_customer_after_accept_in_ms":
        return "Cancelled by the Customer";
      case "event_time_accepted_canceled_by_rider_after_accept_in_ms":
        return "Cancelled by the Bearer";
      case "event_time_accepted_rider_arrived_to_origin_in_ms":
        return "Bearer Arrived to Origin";
      case "event_time_active_parcel_picked_up_in_ms":
        return "Parcel Picked Up";
      case "event_time_active_rider_arrived_to_destination_in_ms":
        return "Bearer Arrived to Destination";
      case "event_time_active_canceled_by_customer_during_delivery_in_ms":
        return "Cancelation requested by the Customer";
      case "event_time_active_canceled_by_rider_during_delivery_in_ms":
        return "Cancelation requested by the Bearer";
      case "event_time_active_parcel_dropped_off_at_destination_in_ms":
        return "Parcel Dropped Off";
      case "event_time_active_completion_confirmed_by_rider_in_ms":
        return "Bearer Confirms Job Completion";
      case "event_time_completed_on_original_details_in_ms":
        return "Order Closed";
      default:
        break;
    }
  };

  const handleTransportLastStepTime = (item) => {
    const firstStep = transport.event_time[0].time;
    let lastStep = 0;

    if (
      transport.event_time[transport.event_time.length - 1].title ===
      "event_time_completed_on_original_details_in_ms"
    ) {
      lastStep = transport.event_time[transport.event_time.length - 2].time;
    } else {
      lastStep = transport.event_time[transport.event_time.length - 1].time;
    }

    const newTime = lastStep - firstStep;
    var min = newTime / 1000 / 60;
    var r = min % 1;
    var sec = Math.floor(r * 60);
    if (sec < 10) {
      sec = "0" + sec;
    }
    min = Math.floor(min);

    if (
      transport.event_time[transport.event_time.length - 1].title ===
      "event_time_completed_on_original_details_in_ms"
    ) {
      if (
        item.time === transport.event_time[transport.event_time.length - 2].time
      ) {
        return min + ":" + sec;
      } else {
        return "";
      }
    } else {
      if (
        item.time === transport.event_time[transport.event_time.length - 1].time
      ) {
        return min + ":" + sec;
      } else {
        return "";
      }
    }
  };


  const renderSpinner = () => {
    if (isLoading) {
      return <Spinner />;
    }
  };

  const adminNextState = async () => {
    setLoading(true);
    try {
      const result = await transportService.adminEditTransportToNextState(transport.transport_id);
      utils.log(result);
      setLoading(false);
      if (result) {
        switch (result.data.code) {
          case 200:
            toast.success(result.data.message);
            onRefresh();
            return;
          case 401:
            toast.error(result.data.message);
            return this.props.history.replace("/login");
          case 500:
            return toast.error(result.data.message);
          default:
            return toast.error(result.data.message);
        }
      }
    } catch (error) {
      toast.error(error.message);
    }
    setLoading(false);
  };
  const adminPreviousState = async () => {
    setLoading(true);
    try {
      const result = await transportService.adminEditTransportToPreviousState(transport.transport_id);
      utils.log(result);
      setLoading(false);
      if (result) {
        switch (result.data.code) {
          case 200:
            toast.success(result.data.message);
            onRefresh();
            return;
          case 401:
            toast.error(result.data.message);
            return this.props.history.replace("/login");
          case 500:
            return toast.error(result.data.message);
          default:
            return toast.error(result.data.message);
        }
      }
    } catch (error) {
      toast.error(error.message);
    }
    setLoading(false);
  };
  return (
    <>
      {renderSpinner()}
      <ToastContainer />

      <div style={{ textAlign: "center" }}>
        <div className="row">
          <div className="timeline-itam-wrapper">
            {transport && transport.event_time
              ? transport.event_time.map((item) => (
                <div key={item.title}>
                  {item.time > 0 ? (
                    <div className="timeline-item-info">
                      {handleTimeStamp(item.time)}
                      <div className="timeline-transport-info">
                        <span className="timeline-transport-last-step">
                          {handleTransportLastStepTime(item)}
                        </span>
                        <span className="timeline-time">
                          {item.time
                            ? utils.timestampToDateTime(item.time)
                            : null}
                        </span>
                        <span className="timeline-name">
                          {handleTitle(item.title)}
                        </span>
                      </div>
                    </div>
                  ) : null}
                </div>
              ))
              : null}
          </div>
        </div>
        <div className="row">
          <div className="col">
            <Space.Compact direction="horizontal">
              <Button size="large" style={{ margin: 20 }} disabled={backDisable} onClick={() => showModal("back")}>Previous Step</Button>
              <Button size="large" style={{ margin: 20 }} disabled={nextDisable} onClick={() => showModal("next")}>Next Step</Button>
            </Space.Compact>
          </div>
        </div>
        <Modal
          title="Caution: Update Order Stage"
          closable={{ 'aria-label': 'Custom Close Button' }}
          open={isModalOpen}
          onOk={handleOk}
          okText="Change"
          onCancel={handleCancel}
        >
          <p>Manually changing the delivery stage may impact both the user and customer experience, as these updates are visible to them.
            Please make sure this is the correct action before proceeding.</p>
        </Modal>
      </div>
    </>
  );
}

export default TransportTimeLine;
